import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Row, Select, Tooltip } from 'antd';
import React, { useState } from 'react';
import AwsSvgIcon from '@/../public/aws-1.svg';
import styles from './index.module.css';
import GLOBAL_META_CONFIG from '@/../config/AllServices';

const DeployStackContent = ({
  handleDeployStack,
  deployStackButtonLoading,
  deployStackCheckboxDisabled,
  deployedCftCheck,
  setDeployedCftCheck,
}) => {
  const [region, setRegion] = useState('us-east-1');

  const allRegions = GLOBAL_META_CONFIG.REGIONS.filter(region => {
    if (region) {
      return true;
    }
    return false;
  });

  return (
    <div>
      <div className={styles['config_info_wrapper']}>
        <div className={styles['config_icon']}>
          <InfoCircleOutlined style={{ color: '#1890ff', fontSize: '1.1em' }} />
        </div>
        <div className={styles['config_info']}>
          <div className={styles['config_info_sub_title']}>Change Protection Level</div>
          <div className={styles['config_info_content']}>
            In this step, you will be deleting a stack from your cloud account. It is the same stack
            you deployed to enable Real-time Threat Detection (Eagle Eye) and Malwares/OS
            Vulnerabilities detection engine (Cloud X-Ray).
          </div>
        </div>
      </div>
      <div className={styles['cardMain']}>
        <Row>
          <Col span={24}>
            <Row
              gutter={24}
              style={{
                marginBottom: '20px',
                display: 'flex',
              }}
            >
              <Col span={14}>
                <div style={{ maxWidth: '50vw' }}>
                  <p>
                    In this step, you will be installing a StackSet into your cloud account. This
                    StackSet deploys required cloud resources in your cloud account: it will enable
                    Real-time threat detection (Eagle Eye) and Malwares/OS Vulnerabilities detection
                    engine (Cloudxray).
                  </p>
                </div>
              </Col>
              <Col span={4}>
                <Tooltip placement="bottom">
                  <Select
                    defaultValue={region}
                    size="medium"
                    style={{
                      width: 140,
                    }}
                    onChange={e => {
                      setRegion(e);
                    }}
                  >
                    {allRegions.map(eachRegion => (
                      <Option value={eachRegion}>{eachRegion}</Option>
                    ))}
                  </Select>
                </Tooltip>
              </Col>
              <Col span={6}>
                <Tooltip placement="bottom">
                  <Button
                    size="medium"
                    style={{ backgroundColor: 'transparent' }}
                    onClick={e => handleDeployStack(region)}
                    loading={deployStackButtonLoading}
                  >
                    <img
                      alt="Aws logo here"
                      style={{ width: 24, marginRight: 10 }}
                      src="/icons/aws_sm_icon.svg"
                    />
                    Deploy Stack
                    <svg
                      style={{ marginLeft: '10px' }}
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.7583 0.0507812H9.48709C9.30628 0.0507812 9.15984 0.197222 9.15984 0.378027C9.15984 0.558659 9.30628 0.705099 9.48709 0.705099H12.7583C12.9041 0.705617 13.0478 0.73912 13.1787 0.80319L6.63889 7.34341C6.57569 7.40437 6.53977 7.48813 6.53908 7.57603C6.53821 7.66375 6.57275 7.74802 6.63475 7.81002C6.69692 7.87219 6.78119 7.90673 6.86892 7.90587C6.95665 7.90518 7.0404 7.86908 7.10136 7.80605L13.642 1.26627C13.7059 1.39717 13.7396 1.54085 13.7401 1.6866V4.95786C13.7401 5.13849 13.8866 5.28493 14.0672 5.28493C14.2478 5.28493 14.3943 5.13849 14.3943 4.95786V1.6866C14.3937 1.25297 14.2214 0.837128 13.9147 0.53063C13.608 0.223933 13.1923 0.0514089 12.7587 0.0508784L12.7583 0.0507812Z"
                        fill="#565656"
                      />
                      <path
                        d="M14.0664 6.5931C13.8858 6.5931 13.7394 6.73954 13.7394 6.92017V12.8088C13.7394 13.069 13.6359 13.3187 13.4518 13.5026C13.2679 13.6867 13.0182 13.7901 12.758 13.7901H6.5427V9.5375C6.54218 9.10387 6.36966 8.68803 6.06295 8.38153C5.75642 8.07483 5.34058 7.90231 4.90698 7.90178H0.654332V1.68649C0.654332 1.42624 0.757772 1.17654 0.941688 0.992456C1.12578 0.80854 1.37549 0.7051 1.63572 0.7051H7.52431C7.70494 0.7051 7.85138 0.558659 7.85138 0.378027C7.85138 0.197222 7.70494 0.0507812 7.52431 0.0507812H1.63572C1.20209 0.0512993 0.786251 0.223818 0.479752 0.530534C0.173055 0.837058 0.000530504 1.2529 0 1.6865V12.809C0.000518081 13.2426 0.173037 13.6582 0.479752 13.9649C0.786277 14.2716 1.20212 14.444 1.63572 14.4445H12.7582C13.1918 14.444 13.6075 14.2716 13.9141 13.9649C14.2208 13.6582 14.3932 13.2425 14.3937 12.809V6.92036C14.3937 6.83367 14.3593 6.75043 14.298 6.68913C14.2366 6.62765 14.1535 6.59328 14.0666 6.59328L14.0664 6.5931ZM0.653992 12.8084V8.55574H4.90664C5.16688 8.55574 5.41659 8.65901 5.60067 8.8431C5.78459 9.02719 5.88803 9.27672 5.88803 9.53713V13.7898H1.63538C1.37514 13.7898 1.12543 13.6863 0.941348 13.5023C0.757431 13.3183 0.653992 13.0686 0.653992 12.8084V12.8084Z"
                        fill="#565656"
                      />
                    </svg>
                  </Button>
                </Tooltip>
              </Col>
            </Row>
            <Row
              gutter={24}
              style={{
                marginBottom: '20px',
              }}
            >
              <Col span={20}>
                <Tooltip
                  placement="bottom"
                  title={deployStackCheckboxDisabled ? 'Please deploy CFT first' : null}
                >
                  <Checkbox
                    disabled={deployStackCheckboxDisabled}
                    checked={deployedCftCheck}
                    name="deployedCftCheck"
                    onChange={e => {
                      setDeployedCftCheck(e.target.checked);
                    }}
                  >
                    I acknowledge that I have deployed the Cloud Formation Template in my account &
                    the creation of resources has been completed.
                  </Checkbox>
                </Tooltip>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default DeployStackContent;
